export default class Live {

    static STATUS_LIVE = 1;
    static STATUS_REST = 2;

    static TYPE_ANCHOR = 1;
    static TYPE_ROBOT = 2;
    static TYPE_CUSTOM = 3;

    user_id = '';
    room_id = 0;
    room_title = '';
    room_cover = '';
    portrait = '';
    live_status = '';
    push_status = '';
    live_url = '';
    live_type = '';
    match_id = '';
    match_type = '';
    groupId = '';

    constructor(live) {
        this.user_id = live.user_id;
        this.room_id = live.room_id;
        this.room_title = live.room_title;
        this.room_cover = live.room_cover;
        this.portrait = live.portrait;
        this.live_status = live.live_status;
        this.push_status = live.push_status;
        this.live_url = live.live_url;
        this.live_type = live.live_type;
        this.match_id = live.match_id;
        this.match_type = live.match_type;
        this.groupId = live.groupId;
    }

    living() {
        if (this.live_type == Live.TYPE_ANCHOR) {
            return this.live_status == Live.STATUS_LIVE && this.push_status == Live.STATUS_LIVE;
        } else if (this.live_type == Live.TYPE_ROBOT || this.live_type == Live.TYPE_CUSTOM) {
            return this.push_status == Live.STATUS_LIVE;
        }
        return false;
    }
}
